/* =====================================================================
   17 NUTRITION – HUISSTIJL (27-09-2026)
   Productpagina: zet getallen met eenheid vet in de korte intro (het
   tekstblok direct boven de vinkjeslijst) en in de vinkjeslijst zelf
   (bijv. "375mg", "500G", "91%", "2:1:1", "180/120", "€1"). De tekst zelf verandert
   niet; alleen de opmaak. Werkt op alle productsjablonen, ook na het
   wisselen van variant.
   ===================================================================== */
(function () {
  var pattern;
  try {
    // getal (met . of , als scheiding) + optionele eenheid; niet midden in een woord en niet in een productnaam (bijv. "Omega-3", "Omega 3", "17 Nutrition")
    pattern = new RegExp('(?<![\\p{L}\\d-])(?<!omega\\s)(?!\\d+\\s*nutrition)((?:€\\s?)?\\d+(?:[.,:/]\\d+)*\\s?(?:mg|mcg|µg|kilogram|gram|kg|g|ml|liter|l|kcal|%)?)(?![\\p{L}\\d])', 'giu');
  } catch (e) {
    // oudere browsers zonder lookbehind: iets eenvoudiger patroon
    pattern = /((?:€\s?)?\b\d+(?:[.,:\/]\d+)*\s?(?:mg|mcg|kilogram|gram|kg|g|ml|liter|l|kcal|%)?)(?![A-Za-z\d])/gi;
  }

  function boldNumbers(root) {
    if (!root || root.dataset.n17Nums === '1') return;
    root.dataset.n17Nums = '1';
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) {
      var n = walker.currentNode;
      if (n.parentElement && n.parentElement.closest('.n17-num')) continue;
      pattern.lastIndex = 0;
      if (pattern.test(n.nodeValue)) nodes.push(n);
    }
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      pattern.lastIndex = 0;
      text.replace(pattern, function (match, _g, offset) {
        if (offset > last) frag.appendChild(document.createTextNode(text.slice(last, offset)));
        var b = document.createElement('b'); // <b>: een <span> krijgt extra ruimte door bestaande thema-CSS
        b.className = 'n17-num';
        b.textContent = match;
        frag.appendChild(b);
        last = offset + match.length;
        return match;
      });
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run() {
    document.querySelectorAll('.features-list').forEach(function (list) {
      list.querySelectorAll('.list-item-text').forEach(boldNumbers);
      var intro = list.previousElementSibling;
      if (intro && intro.classList.contains('product-form__text')) boldNumbers(intro);
    });
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  // Focal vervangt delen van het productformulier bij variantwissel
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { run(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
